(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-gifts/assets/javascripts/redeem/components/play-footer.js') >= 0) return;  svs.modules.push('/modules/ticket-gifts/assets/javascripts/redeem/components/play-footer.js');
"use strict";


const Payfooter = svs.tur.ReactPayfooter.Payfooter;
const WidgetArea = svs.ticket_gifts.components.WidgetArea;
setGlobal('svs.ticket_gifts.redeem.components.PlayFooter', _ref => {
  let ticketInfo = _ref.ticketInfo,
    hasMoreVouchers = _ref.hasMoreVouchers,
    onClick = _ref.onClick,
    receiverSameAsBuyer = _ref.receiverSameAsBuyer;
  const ticketAvailable = ticketInfo.open;
  const text = ticketAvailable ? "K\xF6p ny ".concat(ticketInfo.name) : 'Välj ny lott';
  if (hasMoreVouchers) {
    return React.createElement(Payfooter, {
      buttons: [{
        primary: true,
        text: receiverSameAsBuyer ? 'Skrapa nästa lott' : 'Skrapa nästa presentlott',
        onClick
      }]
    });
  }
  return React.createElement(React.Fragment, null, React.createElement(WidgetArea, {
    areaName: "afterTicketsWidget",
    className: "full-width-widget"
  }), React.createElement(Payfooter, {
    buttons: [{
      primary: true,
      text,
      onClick
    }],
    isFixed: true
  }));
});

 })(window);